import { getProductBadgesRpc as getProductBadgesInAppRpc } from '../../../__generated__/chirp/com/hubspot/monetization/rpc/BadgeInAppService';
import { getProductBadgesRpc as getProductBadgesPublicRpc } from '../../../__generated__/chirp/com/hubspot/monetization/rpc/BadgePublicService';
import { logRavenException } from '../../errorUtils';
import { noAuthRpcClient, rpcClient } from '../../rpcClient';
export const fetchBadges = ({
  productApiNames,
  seatCount,
  isPublicUseCase
}) => {
  let badges = {
    productBadges: {}
  };
  let promiseError = undefined;
  const badgesPromise = isPublicUseCase ? noAuthRpcClient.call(getProductBadgesPublicRpc, {
    request: {
      productApiNames,
      seatCount
    }
  }) : rpcClient.call(getProductBadgesInAppRpc, {
    request: {
      productApiNames,
      seatCount
    }
  });
  return badgesPromise.then(response => {
    badges = response;
  }, error => {
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames,
        seatCount
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchBadges: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames,
        seatCount
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return badges;
  });
};